<template>
  <div id="app">
    <keep-alive v-if="$route.name !== 'login'" include="layout" :key="$store.state.sessionGeneration">
      <router-view />
    </keep-alive>
    <router-view v-else />
  </div>
</template>

<script>
import { clearUserProgress } from '@/api/app'
import { mapActions } from 'vuex'
export default {
  mounted() {
    const isClear = false
    if(isClear) {
      clearUserProgress()
    }
    this.getUserInfoFn();
  },
  methods: {
    ...mapActions([
      'getUserInfoFn'
    ]),
  }
};
</script>

<style lang="scss">
body {
  margin: 0;
  background: #f4f7fb;
}

#app {
  width: 100%;
  max-width: 480PX;
  min-height: 100vh;
  min-height: 100dvh;
  margin: 0 auto;
  background: #fff;
  box-sizing: border-box;
  font-family: PingFang SC, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #3e3e3e;
}
</style>
